/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Joinandstart2Inputs */

const zh_learn_joinandstart2 = /** @type {(inputs: Learn_Joinandstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入并开始`)
};

const en_learn_joinandstart2 = /** @type {(inputs: Learn_Joinandstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join and start`)
};

const es_learn_joinandstart2 = /** @type {(inputs: Learn_Joinandstart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse y empezar`)
};

/**
* | output |
* | --- |
* | "Join and start" |
*
* @param {Learn_Joinandstart2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_joinandstart2 = /** @type {((inputs?: Learn_Joinandstart2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Joinandstart2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_joinandstart2(inputs)
	if (locale === "en") return en_learn_joinandstart2(inputs)
	return es_learn_joinandstart2(inputs)
});
export { learn_joinandstart2 as "learn_joinAndStart" }